module.exports = __webpack_public_path__ + "img/24.6edf3052.png";